export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Delivery-icon.31b77d99.svg","height":79,"width":81,"blurWidth":0,"blurHeight":0};